export const maxExecutiveRanks = {"2023":12,"2024":11,"2025":11,"2026":8}